module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.fill_info == '') ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-9"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v(_vm._s(_vm.form.name))]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "iconclass": "fa fa-pencil",
      "id": "r_nev",
      "label": "Név",
      "name": "r_nev"
    },
    model: {
      value: (_vm.palyazati_adatok.r_nev),
      callback: function($$v) {
        _vm.palyazati_adatok.r_nev = $$v
      },
      expression: "palyazati_adatok.r_nev"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("\n                Kategória\n              ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.palyazati_adatok.r_kat),
      expression: "palyazati_adatok.r_kat"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "r_kat",
      "id": "r_kat"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.palyazati_adatok.r_kat = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.kategoriak), function(opt, i) {
    return _c('option', {
      domProps: {
        "value": opt.value
      }
    }, [_vm._v(_vm._s(opt.text))])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "iconclass": "fa fa-pencil",
      "id": "r_helyszin",
      "label": "Helyszín",
      "name": "r_helyszin"
    },
    model: {
      value: (_vm.palyazati_adatok.r_helyszin),
      callback: function($$v) {
        _vm.palyazati_adatok.r_helyszin = $$v
      },
      expression: "palyazati_adatok.r_helyszin"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "readonly": true,
      "datepicker": true,
      "iconclass": "fa fa-pencil",
      "id": "r_datum",
      "label": "Dátumtól",
      "name": "r_datum"
    },
    model: {
      value: (_vm.palyazati_adatok.r_datum),
      callback: function($$v) {
        _vm.palyazati_adatok.r_datum = $$v
      },
      expression: "palyazati_adatok.r_datum"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "readonly": true,
      "datepicker": true,
      "iconclass": "fa fa-pencil",
      "id": "r_datum_v",
      "label": "Dátumig",
      "name": "r_datum_v"
    },
    model: {
      value: (_vm.palyazati_adatok.r_datum_v),
      callback: function($$v) {
        _vm.palyazati_adatok.r_datum_v = $$v
      },
      expression: "palyazati_adatok.r_datum_v"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "regexp_filter": "[0-9]+",
      "mask": "99:99",
      "iconclass": "fa fa-pencil",
      "id": "r_idopont",
      "label": "Időpontól",
      "name": "r_idopont"
    },
    model: {
      value: (_vm.palyazati_adatok.r_idopont),
      callback: function($$v) {
        _vm.palyazati_adatok.r_idopont = $$v
      },
      expression: "palyazati_adatok.r_idopont"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "regexp_filter": "[0-9]+",
      "mask": "99:99",
      "iconclass": "fa fa-pencil",
      "id": "r_idopont_v",
      "label": "Időpontig",
      "name": "r_idopont_v"
    },
    model: {
      value: (_vm.palyazati_adatok.r_idopont_v),
      callback: function($$v) {
        _vm.palyazati_adatok.r_idopont_v = $$v
      },
      expression: "palyazati_adatok.r_idopont_v"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "iconclass": "fa fa-pencil",
      "id": "r_celcsop",
      "label": "Célcsoport",
      "name": "r_celcsop"
    },
    model: {
      value: (_vm.palyazati_adatok.r_celcsop),
      callback: function($$v) {
        _vm.palyazati_adatok.r_celcsop = $$v
      },
      expression: "palyazati_adatok.r_celcsop"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "regexp_filter": "[0-9]+",
      "iconclass": "fa fa-pencil",
      "id": "r_rsz",
      "label": "Résztvevők tervezett száma",
      "name": "r_rsz"
    },
    model: {
      value: (_vm.palyazati_adatok.r_rsz),
      callback: function($$v) {
        _vm.palyazati_adatok.r_rsz = $$v
      },
      expression: "palyazati_adatok.r_rsz"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('inputbox', {
    attrs: {
      "disabled": true,
      "errors": _vm.errors,
      "iconText": "Ft",
      "id": "r_osszk",
      "label": "Összköltség",
      "name": "r_osszk"
    },
    model: {
      value: (_vm.palyazati_adatok.r_osszk),
      callback: function($$v) {
        _vm.palyazati_adatok.r_osszk = $$v
      },
      expression: "palyazati_adatok.r_osszk"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('inputbox', {
    attrs: {
      "errors": _vm.errors,
      "regexp_filter": "[0-9]+",
      "iconText": "Ft",
      "id": "r_igt",
      "label": "Igényelt támogatás",
      "name": "r_igt"
    },
    model: {
      value: (_vm.palyazati_adatok.r_igt),
      callback: function($$v) {
        _vm.palyazati_adatok.r_igt = $$v
      },
      expression: "palyazati_adatok.r_igt"
    }
  })], 1)]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h6', [_vm._v("Bevételek")]), _vm._v(" "), _c('BevetelKiadasElem', {
    attrs: {
      "global_errors": _vm.errors,
      "id": "penzbeli_tamogatas",
      "elemek": _vm.palyazati_adatok.bevetelek
    }
  }), _vm._v(" "), _c('BevetelKiadasElem', {
    attrs: {
      "global_errors": _vm.errors,
      "id": "atvallalt_koltsegek",
      "elemek": _vm.palyazati_adatok.bevetelek
    }
  }), _vm._v(" "), _c('BevetelKiadasElem', {
    attrs: {
      "global_errors": _vm.errors,
      "id": "termektamogatas",
      "elemek": _vm.palyazati_adatok.bevetelek
    }
  }), _vm._v(" "), _c('BevetelKiadasElem', {
    attrs: {
      "global_errors": _vm.errors,
      "id": "hallgatoi_hozzajarulas",
      "elemek": _vm.palyazati_adatok.bevetelek
    }
  }), _vm._v(" "), _c('BevetelKiadasElem', {
    attrs: {
      "global_errors": _vm.errors,
      "id": "egyeb_tamogatas",
      "elemek": _vm.palyazati_adatok.bevetelek
    }
  }), _vm._v(" "), _c('h6', [_vm._v("Kiadások")]), _vm._v(" "), _c('BevetelKiadasElem', {
    attrs: {
      "global_errors": _vm.errors,
      "id": "anyagkoltseg",
      "elemek": _vm.palyazati_adatok.kiadasok
    }
  }), _vm._v(" "), _c('BevetelKiadasElem', {
    attrs: {
      "global_errors": _vm.errors,
      "id": "szolgaltatasok",
      "elemek": _vm.palyazati_adatok.kiadasok
    }
  }), _vm._v(" "), _c('BevetelKiadasElem', {
    attrs: {
      "global_errors": _vm.errors,
      "id": "egyeb_koltsegek",
      "elemek": _vm.palyazati_adatok.kiadasok
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "revenue-expense-summ-row"
  }, [_vm._v("\n          Összes bevétel: "), _c('span', [_vm._v(_vm._s(_vm.bevetelKalkulacio))])]), _vm._v(" "), _c('div', {
    staticClass: "revenue-expense-summ-row"
  }, [_vm._v("\n          Összes kiadás: "), _c('span', [_vm._v(_vm._s(_vm.kiadasKalkulacio))])]), _vm._v(" "), _c('div', {
    staticClass: "revenue-expense-summ-row"
  }, [_vm._v("\n          Rendezvény költségvetése: "), _c('span', [_vm._v(_vm._s(_vm.koltsegvetesKalkulacio))])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('textareabox', {
    attrs: {
      "cstyle": "min-height: 100px",
      "placeholder": "A rendezvény bemutatása",
      "maxlength": "2000",
      "autogrow": true,
      "iconclass": "fa fa-pencil",
      "id": "rendezveny_leiras",
      "label": "A rendezvény bemutatása",
      "name": "rendezveny_leiras"
    },
    model: {
      value: (_vm.palyazati_adatok.rendezveny_leiras),
      callback: function($$v) {
        _vm.palyazati_adatok.rendezveny_leiras = $$v
      },
      expression: "palyazati_adatok.rendezveny_leiras"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "type": "button",
      "name": "kuld",
      "disabled": !_vm.save_enabled
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Beküld")])])], 1)])]) : _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v(_vm._s(_vm.form.name))]), _vm._v(" "), _c('div', {
    staticClass: "article-text",
    domProps: {
      "innerHTML": _vm._s(_vm.fill_info)
    }
  }, [_vm._v(_vm._s(_vm.fill_info))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-3"
  }, [_c('div', {
    staticClass: "info-box warning"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)",
      "title": "Kitöltési útmutató"
    }
  }, [_vm._v("Kitöltési útmutató letöltése")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticClass: "form-block-title-layout-tab"
  }, [_c('span', [_vm._v("Rendezvény adatai")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticClass: "form-block-title-layout-tab"
  }, [_c('span', [_vm._v("\n            Rendezvény költségvetése\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h5', {
    staticClass: "form-block-title-layout-tab"
  }, [_c('span', [_vm._v("\n            Rendezvény bemutatása\n          ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5935c334"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/competition/rendezveny_szervezes_tamogatasi_palyazat.vue
// module id = 374
// module chunks = 0